export const ADD_LIST_ASSET = 'Add List Asset';
export const TRIGGER_SEARCH = 'Trigger Search';
export const FINISH_SEARCH = 'Finish Search';
export const UPDATE_FACETS = 'Update Facets';
export const SET_FACETS = 'Set Facets';
export const FETCHING_FACETS_ERROR = 'Fetching Facets Error';
export const SET_ROOT_ORGANIZATIONS = 'Set Root Organizations';
